import React from 'react';
import { Text } from './Text';
/**
 * We need to consult that with UX team.
 * I picked values closest to what we already have in old @gr/ui.
 */
const marginBottomPerHeadingLevel = {
    '1': 'none',
    '2': 'none',
    '3': 'base',
    '4': 'base',
    '5': 'base',
    '6': 'base',
};
const textVariantPerHeadingLevel = {
    1: 'header-1',
    2: 'header-2',
    3: 'header-3',
    4: 'header-4',
    5: 'header-4',
    6: 'header-4',
};
/**
 * `Heading` is used to create various levels of typographic hierarchies. `Heading` composes the `Text` component.
 * Renders `h2` by default.
 *
 * @see https://fe-docs.int.getresponse.com/gr-ui-neo/index.html?path=/docs/components-text--using-predefined-text-variant#heading
 */
export const Heading = ({ children, level = 2, ...textProps }) => {
    const marginBottom = marginBottomPerHeadingLevel[level];
    const tag = `h${level}`;
    const textVariant = textVariantPerHeadingLevel[level];
    return (React.createElement(Text, { marginBottom: textProps.margin ? undefined : marginBottom, variant: textVariant, tag: tag, margin: 0, padding: 0, ...textProps }, children));
};
